export default __webpack_public_path__ + "static/media/portugal.cdb95931.png";